import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './config/environment';
import { initSentry } from './config/sentry-init';

initSentry(environment);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
